import React, { useState, useContext, useEffect, Fragment } from 'react';
import axios from 'axios';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import { NavLink } from 'react-router-dom';
import { LoginContext } from '../../hooks/context/LoginContext';
import { Spinner } from 'react-bootstrap';
import { Modal } from 'react-bootstrap';
import FormRow from './FormRow';
import MiSelect from './MiSelect';
import FormInput from './FormInput';
import CheckIos from '../ui/CheckIos';
import { alertService } from '../../services/alertservice';
import { axiosPost, getApiUrl } from '../../helpers/helperApp';


function GoToRunCicCfg(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const { idDoc, flatBtn, swal, infoDocActual, docBloqueado, origenProp } = props;

    const { apiKey, confApp, cicDefAgeInv, cicDefAgeCom, cicDefAgeEdi, cicDefAgeSup, cicDefAgeMan, cicDefAge } = useContext(LoginContext);
    
    const [ sendingIniciar, saveSendingIniciar ] = useState(false);
    const [ valModalResponsable, saveValModalResponsable ] = useState(0);
    const [ valModalCentro, saveValModalCentro ] = useState(0);
    const [ valModalCiclos, saveValModalCiclos ] = useState(0);
    const [ optionsCiclos, saveOptionsCiclos ] = useState([]);
    const [ loadingCiclos, saveLoadingCiclos ] = useState(false);
    const [ showModalIniciar, saveShowModalIniciar ] = useState(false);
    const [ optionsGoToRunCicCfg, saveOptionsGoToRunCicCfg ] = useState({idCic: 0, app_Cic_Code: '', idAge2: 0, idCen: 0, idTip: 0});
    const [ valModalDescripcion, saveValModalDescripcion ] = useState("");
    const [ valModalIncludeCero, saveValModalIncludeCero ] = useState(false);
    const [ origen, saveOrigen ] = useState(origenProp);    

    useEffect( () => {
        
        loadOptionsGoToRunCicCfg();        
              
        return () =>{
            // Token cancelación axios al desmontar componentes
            source.cancel();                    
        } 

    },[idDoc, docBloqueado])    

    const loadOptionsGoToRunCicCfg = async () => {        
        saveSendingIniciar(true);               

        const data = new FormData(); 
        data.append("validacion", apiKey());                
        data.append("iddoc", idDoc);        
        
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+confApp.supply.controles.modaliniciar.loadoptionsgotorunciccfg, data, source.token);
        if( typeof respuesta.data === "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: true});  
        }else{            
            saveOptionsGoToRunCicCfg(prevState => ({...prevState, ...respuesta.data[0]}));            
        }

        saveSendingIniciar(false);
    }
    
    const Iniciar = async () => {
        if(swal){
            const startTime = Date.now();
            const intervalId = setInterval(() => {
                const swal = document.querySelector('.swal-overlay');
                if (swal) {
                    clearInterval(intervalId);
                    swal.remove();
                } else if (Date.now() - startTime > 5000) {
                    clearInterval(intervalId);                            
                }
            }, 100);
        }                
        let defAge = 0;        
        switch(true){
            case window.location.pathname.toLowerCase().includes('edirapinv'):
            case window.location.pathname.toLowerCase().includes('largeinv'):
                defAge = cicDefAgeInv == '' ? cicDefAge : cicDefAgeInv ;
                break;

            case window.location.pathname.toLowerCase().includes('edirapcom'):
            case window.location.pathname.toLowerCase().includes('largecom'):
                defAge = cicDefAgeCom == '' ? cicDefAge : cicDefAgeCom ;
                    break;

            case window.location.pathname.toLowerCase().includes('edirap'):
                defAge = cicDefAgeEdi == '' ? cicDefAge : cicDefAgeEdi ;
                    break;

            case window.location.pathname.toLowerCase().includes('supply'):
                defAge = cicDefAgeSup == '' ? cicDefAge : cicDefAgeSup ;
                    break;
            
            case window.location.pathname.toLowerCase().includes('inicio'):
                defAge = cicDefAgeMan == '' ? cicDefAge : cicDefAgeMan ;
                    break;
        }        
        // saveValModalResponsable(optionsGoToRunCicCfg.idAge2);
        saveValModalResponsable(defAge);
        saveValModalCentro(optionsGoToRunCicCfg.idCen);
        saveValModalDescripcion(infoDocActual != null ? infoDocActual.nomdocnohtml : "" );
        saveValModalIncludeCero(false);
        await loadOptionsCboCiclos(confApp.supply.controles.modaliniciar.ciclos.data, saveOptionsCiclos, saveLoadingCiclos);        
        saveShowModalIniciar(true);
    }

    const IniciarCall = async () => {        
        saveSendingIniciar(true);
        saveShowModalIniciar(false);
        saveOrigen("/runciccfg");                

        const data = new FormData(); 
        data.append("validacion", apiKey());                
        data.append("idaprov", idDoc);
        data.append("idage2", valModalResponsable);
        data.append("idcen", valModalCentro);
        data.append("nom1", valModalDescripcion == "" ? "null" : valModalDescripcion);
        // data.append("includecero", valModalIncludeCero);
        
        const respuestaIniciar = await axiosPost(getApiUrl(window.location.origin)+confApp.supply.controles.modaliniciar.senddata, data, source.token);       
        if( respuestaIniciar.data === false ){            
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${confApp.supply.controles.modaliniciar.error.title}`, {autoClose: true});            
        }else if( typeof respuestaIniciar.data === "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuestaIniciar.data}`, {autoClose: true});  
        }else{
            // Redirigir a /runciccfg  
            window.location.href = `/runciccfg/${valModalCiclos}/${idDoc}/${valModalCentro}/${valModalResponsable}/${valModalDescripcion == "" ? "null" : valModalDescripcion}/${valModalIncludeCero}/${origen}`;
        }

        saveSendingIniciar(false);
    }

    const loadOptionsCboCiclos = async (url, saveOptions, saveLoading) =>{
        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("idtip", optionsGoToRunCicCfg.idTip);                                                      
        const respuesta = await axios.post(getApiUrl(window.location.origin)+url, data);
        saveOptions(respuesta.data);
        if(respuesta.data.length == 1){
            saveValModalCiclos(respuesta.data[0]["value"]);
        }
        saveLoading(true);
    }

    const handleSelect= (selectedItem, nameOfComponent, saveData) => {
        if( selectedItem ){
            saveData(selectedItem.value) 
        }else{
            saveData(0)
        }
    }

    const handleInput = (e, save) => {        
        save(e.target.value)
    }

    const handleCheck = (e) => {        
        if( e.target.checked ){              
            saveValModalIncludeCero(true);
        }else{
            saveValModalIncludeCero(false);
        }
    }

    return(
        <Fragment>
            {
            idDoc == null || idDoc == undefined || idDoc == 0
            ?
            null
            :
            optionsGoToRunCicCfg.idCic != 0 && optionsGoToRunCicCfg.idCic != undefined
            ?                
                <NavLink to={"runciccfg/"+idDoc} className={flatBtn == true ? "btn btn-flat btn-success" : "btn btn-success" } >                    
                    {optionsGoToRunCicCfg.app_Cic_Code}
                </NavLink>
            :            
                <button 
                    type="button" 
                    onClick={ Iniciar } 
                    className={ flatBtn == true && swal == true
                                ? "btn btn-flat btn-success mb-1 mr-1 mt-1"
                                : flatBtn != true && swal == true
                                ? "btn btn-success mb-1 mr-1 mt-1"
                                : flatBtn == true && swal != true 
                                ? "btn btn-success btn-flat col-2 mb-1 mr-1 mt-1"
                                : "btn btn-success col-2 mb-1 mr-1 mt-1" }
                    disabled={ sendingIniciar || docBloqueado ? true : false } 
                >               
                {   
                    sendingIniciar
                    ? 
                        <Spinner as="span" animation="border" size="sm" />
                    :
                        <Fragment>
                            <i className="fad fa-recycle md-1"></i>
                            <span className='pl-1'>{confApp.supply.controles.btniniciar.title }</span>    
                        </Fragment>
                }
                </button>
            }            
            <Modal
                show={showModalIniciar}
                onHide={ () => saveShowModalIniciar(false)}                            
                aria-labelledby="example-custom-modal-styling-title"
                centered={true}                    
                dialogClassName="modal-90w"                                             
            > 
                <Modal.Header closeButton>
                    <h4>{confApp.supply.controles.modaliniciar.header.title}</h4>
                </Modal.Header>                         
                <Modal.Body>
                    <FormRow>
                        <MiSelect  
                            estadoForm=  { "" }
                            val=         { valModalCentro }   
                            loading=     { sendingIniciar ? true : false }
                            id=          { confApp.supply.controles.modaliniciar.idcen.id }    
                            name=        { confApp.supply.controles.modaliniciar.idcen.name }   
                            label=       { confApp.supply.controles.modaliniciar.idcen.label }    
                            placeholder= { confApp.supply.controles.modaliniciar.idcen.placeholder }
                            col=         { confApp.supply.controles.modaliniciar.idcen.col } 
                            isClearable= { confApp.supply.controles.modaliniciar.idcen.isclearable }
                            isSearchable={ confApp.supply.controles.modaliniciar.idcen.issearchable }
                            dataType=    { confApp.supply.controles.modaliniciar.idcen.datatype }
                            data=        { confApp.supply.controles.modaliniciar.idcen.data }
                            required=    { confApp.supply.controles.modaliniciar.idcen.required } 
                            disabled=  { confApp.supply.controles.modaliniciar.idcen.disabled }
                            readOnly =   { confApp.supply.controles.modaliniciar.idcen.readonly }
                            disablethisid={confApp.supply.controles.modaliniciar.idcen.disablethisid}
                            disableids={ confApp.supply.controles.modaliniciar.idcen.disableids}
                            formulario= { {id:0} }   
                            change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalCentro) }
                        />
                        <MiSelect  
                            estadoForm=  { "" }
                            val=         { valModalResponsable }   
                            loading=     { sendingIniciar ? true : false }
                            id=          { confApp.supply.controles.modaliniciar.idage2.id }    
                            name=        { confApp.supply.controles.modaliniciar.idage2.name }   
                            label=       { confApp.supply.controles.modaliniciar.idage2.label }    
                            placeholder= { confApp.supply.controles.modaliniciar.idage2.placeholder }
                            col=         { confApp.supply.controles.modaliniciar.idage2.col } 
                            isClearable= { confApp.supply.controles.modaliniciar.idage2.isclearable }
                            isSearchable={ confApp.supply.controles.modaliniciar.idage2.issearchable }
                            dataType=    { confApp.supply.controles.modaliniciar.idage2.datatype }
                            data=        { confApp.supply.controles.modaliniciar.idage2.data }
                            required=    { confApp.supply.controles.modaliniciar.idage2.required } 
                            disabled=  { confApp.supply.controles.modaliniciar.idage2.disabled }
                            readOnly =   { confApp.supply.controles.modaliniciar.idage2.readonly }
                            disablethisid={confApp.supply.controles.modaliniciar.idage2.disablethisid}
                            disableids={ confApp.supply.controles.modaliniciar.idage2.disableids}
                            formulario= { {id:0} }   
                            change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalResponsable) }
                        />
                    </FormRow>
                    <FormRow>
                        {
                            optionsCiclos.length === 0 
                            ?
                                <div className="alert alert-danger text-center col-12" role="alert">
                                    {confApp.supply.controles.modaliniciar.txterror.title}
                                </div>
                            :
                                <MiSelect  
                                    estadoForm=  { "" }
                                    val=         { valModalCiclos }   
                                    loading=     { sendingIniciar ? true : false }
                                    id=          { confApp.supply.controles.modaliniciar.ciclos.id }    
                                    name=        { confApp.supply.controles.modaliniciar.ciclos.name }   
                                    label=       { confApp.supply.controles.modaliniciar.ciclos.label }    
                                    placeholder= { confApp.supply.controles.modaliniciar.ciclos.placeholder }
                                    col=         { confApp.supply.controles.modaliniciar.ciclos.col } 
                                    isClearable= { confApp.supply.controles.modaliniciar.ciclos.isclearable }
                                    isSearchable={ confApp.supply.controles.modaliniciar.ciclos.issearchable }
                                    dataType=    { "codigo" }
                                    data=        { optionsCiclos }
                                    required=    { confApp.supply.controles.modaliniciar.ciclos.required } 
                                    disabled=  { confApp.supply.controles.modaliniciar.ciclos.disabled }
                                    readOnly =   { confApp.supply.controles.modaliniciar.ciclos.readonly }
                                    disablethisid={confApp.supply.controles.modaliniciar.ciclos.disablethisid}
                                    disableids={ confApp.supply.controles.modaliniciar.ciclos.disableids}
                                    formulario= { {id:0} }   
                                    change= { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent, saveValModalCiclos) }
                                />

                        }
                    </FormRow>
                    <FormRow>
                        <FormInput                                                        
                            estadoForm= { confApp.supply.controles.modaliniciar.estadoform }
                            value=      { valModalDescripcion }
                            loading=    { sendingIniciar ? true : false }
                            id=         { confApp.supply.controles.modaliniciar.nom1.id }   
                            type=       { confApp.supply.controles.modaliniciar.nom1.type }  
                            name=       { confApp.supply.controles.modaliniciar.nom1.name }   
                            label=      { confApp.supply.controles.modaliniciar.nom1.label }                                                       
                            placeholder={ confApp.supply.controles.modaliniciar.nom1.placeholder }    
                            col=        { confApp.supply.controles.modaliniciar.nom1.col } 
                            required=   { confApp.supply.controles.modaliniciar.nom1.required }
                            readonly=   { confApp.supply.controles.modaliniciar.nom1.readonly }                                                
                            disabled=   { confApp.supply.controles.modaliniciar.nom1.disabled }
                            change=     { e => handleInput(e, saveValModalDescripcion) }
                            onBlur=     {null} 
                        />
                    </FormRow>
                    <FormRow>
                        <CheckIos                                
                            val= { valModalIncludeCero }
                            name={null}
                            label={ confApp.supply.controles.modaliniciar.check.label }                                
                            id={'checkfirma'}
                            col={"12"}
                            change={ handleCheck }
                            required={ false }
                            disabled={ false }                               
                        />
                    </FormRow>
                    <p className="font-italic text-center">{ confApp.supply.controles.modaliniciar.txtrequired.title }</p>
                </Modal.Body>
                <Modal.Footer>
                    <div className='text-right'>
                        <button 
                                className="btn btn-success mt-1 mr-1"
                                onClick={ () => IniciarCall() }
                                disabled={valModalResponsable == 0 || valModalCiclos == 0 || valModalCentro == 0 ? true : false}
                        >
                            {confApp.supply.controles.modaliniciar.btnaceptar.title}
                        </button>                        
                        <button 
                                className="btn btn-danger mt-1"
                                onClick={ () => saveShowModalIniciar(false) }                                        
                        >
                            {confApp.supply.controles.modaliniciar.btncancelar.title}
                        </button>                                            
                    </div>
                </Modal.Footer>                            
            </Modal> 
        </Fragment>                    
            
    )
}

export default GoToRunCicCfg;